import React, { useState } from "react";
import { CloseIcon } from "../../constant/svgs";
import { OpenIcon } from "../../constant/svgs";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  SPECIAL_CHARACTER_ARRAY,
  SPECIAL_CHARACTER_ARRAY_FOR_ADDRESS,
  VALIDATIONS,
  PASSWORD_FORMAT,
  VALIDATIONS_TEXT,
} from "../../constant/app-constant";
const SigninForm = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const password = watch("password");
  const navigate = useNavigate();
  const onSubmit = (data) => {
    navigate("/home");
  };

  return (
    <>
      <div>
        <div>
          <h1>Sign In</h1>
          <p>Enter your Email and Password for login</p>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <div>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  maxLength={VALIDATIONS.EMAIL}
                  {...register("email", {
                    maxLength: {
                      value: VALIDATIONS.EMAIL,
                      message: VALIDATIONS_TEXT.EMAIL_MAX,
                    },
                    required: {
                      value: true,
                      message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                    },
                    pattern: {
                      value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                      message: VALIDATIONS_TEXT.EMAIL_FORMAT,
                    },
                  })}
                />
                {errors.email && (
                  <small className="text-red error_from">
                    {errors.email.message}
                  </small>
                )}
                {/* <div className="error_from">Please Email Filed is Required</div> */}
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <div>
                <Form.Control
                  type={!showCurrentPassword ? "password" : "text"}
                  placeholder="Enter your password"
                  maxLength={VALIDATIONS_TEXT.PASSWORD_MAX}
                  {...register("password", {
                    minLength: {
                      value: VALIDATIONS.PASSWORD_MIN,
                      message: VALIDATIONS_TEXT.PASSWORD_MIN,
                    },
                    maxLength: {
                      value: VALIDATIONS.PASSWORD_MAX,
                      message: VALIDATIONS_TEXT.PASSWORD_MAX,
                    },
                    required: {
                      value: true,
                      message: VALIDATIONS_TEXT.PASSWORD_REQUIRED,
                    },
                    pattern: {
                      value: /^(?=.*?[A-Z])(?=.*?[a-z]).{8,}$/,
                      message: VALIDATIONS_TEXT.PASSWORD_FORMAT,
                    },
                  })}
                />
                {errors.password && (
                  <small className="text-red error_from">
                    {errors.password.message}
                  </small>
                )}
                {/* <div className="error_from">
                Please Psssword Filed is Required
              </div> */}
              </div>
              <span className="iconfeild">
                {showCurrentPassword ? (
                  <span
                    className="toggle-password"
                    onClick={() => setShowCurrentPassword(false)}
                  >
                    <OpenIcon />
                  </span>
                ) : (
                  <span
                    onClick={() => setShowCurrentPassword(true)}
                    className="toggle-password"
                  >
                    <CloseIcon />
                  </span>
                )}
              </span>
            </Form.Group>
            <div className="from_box btn-commom mt-40">
              <Button type="submit">Sign In</Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SigninForm;
